export default "__VITE_ASSET__BVVjYIkj__"